import { SURVEY_COLORS } from "./theme-constants";

interface TrainingNeedsAnalysisStylesProps {
  isMobile: boolean;
}

export const getSharedStyles = (theme: any) => ({
  container: {
    padding: (props: TrainingNeedsAnalysisStylesProps) => (props.isMobile ? "16px" : "24px"),
    [theme.breakpoints.down("sm")]: {
      padding: "16px",
      height: "auto",
      overflowY: "visible" as const,
    },
  },
  primaryButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "0 16px",
    backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
    color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    border: "none",
    textTransform: "none" as const,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-endIcon": {
      marginLeft: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
    "&:disabled": {
      opacity: 0.5,
      backgroundColor: SURVEY_COLORS.BUTTON_PRIMARY,
      color: SURVEY_COLORS.MODAL_TEXT_WHITE,
    },
  },
  outlineButton: {
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 600,
    height: "40px",
    padding: "0 16px",
    backgroundColor: "transparent",
    color: SURVEY_COLORS.TEXT_PRIMARY,
    border: `1px solid ${SURVEY_COLORS.BORDER_DEFAULT}`,
    textTransform: "none" as const,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "& .MuiButton-startIcon": {
      marginRight: "4px",
      "& svg": {
        fontSize: "12px !important",
      },
    },
    "&:hover": {
      backgroundColor: SURVEY_COLORS.BUTTON_HOVER_BG,
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${SURVEY_COLORS.BLACK}`,
      fontWeight: 700,
      "& .MuiTouchRipple-child": {
        backgroundColor: "transparent",
      },
    },
  },
});
